import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CoordinatorManageSignupsPageForShift } from './coordinatorManageSignupsPageForShift';
import { featureIsEnabled, useFeatures } from '../../hooks/features';
import { NAVIGATION_REDESIGN } from '../../utils/constants';
import { ActivitySidebar } from '../myActivity/sideNav';

export function CoordinatorManageSignupsPage() {
  const [searchParams] = useSearchParams();
  const features = useFeatures();
  const urlFeatures = searchParams.get('features');
  const shiftId = searchParams.get('shiftId');
  const coordinatorActivityUrl = `/coordinator-activity${urlFeatures ? '?features=' + urlFeatures : ''}`;

  const isNewNav = featureIsEnabled(NAVIGATION_REDESIGN, features, searchParams);
  const navigation = isNewNav ? undefined : <ActivitySidebar baseUrl={coordinatorActivityUrl} />;

  if (shiftId) {
    return <CoordinatorManageSignupsPageForShift navigation={navigation} />;
  }
  // TODO support managing signups for event cross all shifts : https://issues.amazon.com/issues/cce-6410
  return null;
}
